import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { value: 1 }
const _hoisted_2 = {
  key: 0,
  value: 2
}
const _hoisted_3 = {
  key: 1,
  value: 4
}
const _hoisted_4 = {
  key: 2,
  value: 12
}
const _hoisted_5 = { value: 1 }
const _hoisted_6 = {
  key: 0,
  value: 2
}
const _hoisted_7 = {
  key: 1,
  value: 4
}
const _hoisted_8 = {
  key: 2,
  value: 12
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["required", "aria-required"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["required", "aria-required"]
const _hoisted_15 = ["required", "aria-required"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["required", "aria-required"]
const _hoisted_18 = ["required", "aria-required"]
const _hoisted_19 = ["required", "aria-required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, { titel: "Zahlungsdaten" }),
    (!_ctx.istEinmalbeitrag && !_ctx.istFerienhaus)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, {
              "zeige-info": true,
              "info-box-id": "tariffPaymentFrequencyInfo"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("Zahlungsweise")
              ])),
              _: 1,
              __: [10]
            }),
            _createVNode(_component_zelle, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "tariffPaymentFrequency",
                  name: "tariffPaymentFrequency",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.zahlungsweise) = $event)),
                  class: "c-form-control-select",
                  "data-cy": "zahlungsweise",
                  required: "",
                  "aria-required": "true",
                  tabindex: "0",
                  "data-fehlermeldung": "Bitte wählen Sie eine Zahlungsweise aus.",
                  "aria-label": "Zahlungsweise",
                  "aria-describedby": "tariffPaymentFrequencyInfo"
                }, [
                  _createElementVNode("option", _hoisted_1, " Jährlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].jaehrlich)), 1),
                  (_ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].halbjaehrlich >= 25)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_2, " Halbjährlich - " + _toDisplayString(_ctx.formatCurrency(
              _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].halbjaehrlich,
            )), 1))
                    : _createCommentVNode("", true),
                  (
            _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].vierteljaehrlich >= 25
          )
                    ? (_openBlock(), _createElementBlock("option", _hoisted_3, " Vierteljährlich - " + _toDisplayString(_ctx.formatCurrency(
              _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].vierteljaehrlich,
            )), 1))
                    : _createCommentVNode("", true),
                  (_ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].monatlich >= 25)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_4, " Monatlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].monatlich)), 1))
                    : _createCommentVNode("", true)
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.piniaStore.state.tarifinformationen.zahlungsweise,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler.tariffPaymentFrequency,
                  "reduzierter-abstand": true
                }, null, 8, ["fehler-text"]),
                _createVNode(_component_info_box, { id: "tariffPaymentFrequencyInfo" }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" Die Teilzahlungszuschläge betragen bei:"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - halbjährlicher Zahlung 3% p.a. nominal (12,75% effektiver Jahreszins),"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - vierteljährlicher Zahlung 5% p.a. nominal (14,10% effektiver Jahreszins),"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - monatlicher Zahlung 5% p.a. nominal (11,35% effektiver Jahreszins). ")
                  ])),
                  _: 1,
                  __: [11]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.istEinmalbeitrag && _ctx.istFerienhaus)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, {
              "zeige-info": true,
              "info-box-id": "tariffPaymentFrequencyInfo"
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("Zahlungsweise")
              ])),
              _: 1,
              __: [12]
            }),
            _createVNode(_component_zelle, null, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "tariffPaymentFrequency",
                  name: "tariffPaymentFrequency",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.zahlungsweise) = $event)),
                  class: "c-form-control-select",
                  "data-cy": "zahlungsweise",
                  required: "",
                  "aria-required": "true",
                  "data-fehlermeldung": "Bitte wählen Sie eine Zahlungsweise aus.",
                  "aria-label": "Zahlungsweise",
                  "aria-describedby": "tariffPaymentFrequencyInfo"
                }, [
                  _createElementVNode("option", _hoisted_5, " Jährlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisJaehrlichFH)), 1),
                  (_ctx.pruefeHalbjaehrlichFH)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_6, " Halbjährlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisHalbjaehrlichFH)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.pruefeVierteljaehrlichFH)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_7, " Vierteljährlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisVieteljaehrlichFH)), 1))
                    : _createCommentVNode("", true),
                  (_ctx.pruefeMonatlichFH)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_8, " Monatlich - " + _toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisMonatlichFH)), 1))
                    : _createCommentVNode("", true)
                ], 512), [
                  [
                    _vModelSelect,
                    _ctx.piniaStore.state.tarifinformationen.zahlungsweise,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler.tariffPaymentFrequency,
                  "reduzierter-abstand": true
                }, null, 8, ["fehler-text"]),
                _createVNode(_component_info_box, { id: "tariffPaymentFrequencyInfo" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode(" Die Teilzahlungszuschläge betragen bei:"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - halbjährlicher Zahlung 3% p.a. nominal (12,75% effektiver Jahreszins),"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - vierteljährlicher Zahlung 5% p.a. nominal (14,10% effektiver Jahreszins),"),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" - monatlicher Zahlung 5% p.a. nominal (11,35% effektiver Jahreszins). ")
                  ])),
                  _: 1,
                  __: [13]
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_zeile, { "spacing-y": false }, {
      default: _withCtx(() => [
        _createVNode(_component_titel_zelle, null, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("Zahlungsart")
          ])),
          _: 1,
          __: [14]
        }),
        _createVNode(_component_zelle, { class: "mkRadio" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.zahlungsart) = $event)),
              type: "radio",
              id: "paymentMethodDebit",
              name: "paymentMethod",
              value: "debit",
              "data-cy": "zahlungsartLastschrift",
              required: "",
              "aria-required": "true",
              "aria-label": "Lastschrift",
              "data-fehlermeldung": "Bitte wählen Sie eine Zahlungsart aus."
            }, null, 512), [
              [_vModelRadio, _ctx.piniaStore.state.zahlungsdaten.zahlungsart]
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("label", {
              for: "paymentMethodDebit",
              class: "radiolabel"
            }, "Lastschrift", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.zahlungsart) = $event)),
              type: "radio",
              id: "paymentMethodInvoice",
              name: "paymentMethod",
              value: "invoice",
              "data-cy": "zahlungsartRechnung",
              disabled: !_ctx.rechnungszahlungAktiv,
              "aria-label": "Rechnung"
            }, null, 8, _hoisted_9), [
              [_vModelRadio, _ctx.piniaStore.state.zahlungsdaten.zahlungsart]
            ]),
            _createElementVNode("label", {
              for: "paymentMethodInvoice",
              class: "radiolabel",
              style: _normalizeStyle({
          color: !_ctx.rechnungszahlungAktiv ? '#898989' : 'unset',
        })
            }, [
              _cache[15] || (_cache[15] = _createTextVNode(" Rechnung ")),
              (!_ctx.istEinmalbeitrag)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "  (nur bei jährlicher Zahlungsweise) "))
                : _createCommentVNode("", true)
            ], 4),
            _createVNode(_component_validierungs_fehler, {
              "fehler-text": _ctx.fehler.paymentMethod,
              "reduzierter-abstand": true
            }, null, 8, ["fehler-text"])
          ]),
          _: 1,
          __: [16]
        })
      ]),
      _: 1
    }),
    (_ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit')
      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
          _createVNode(_component_zeile, { "spacing-y": false }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Der Kontoinhaber ist")
                ])),
                _: 1,
                __: [17]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "paymentAccountHolderCustomer",
                    name: "paymentAccountHolder",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle) = $event)),
                    value: 'versicherungsnehmer',
                    required: _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                    "aria-required": _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                    "aria-label": "Der Kontoinhaber ist der Versicherungsnehmer",
                    "data-fehlermeldung": "Sind Sie selbst oder eine andere Person der Kontoinhaber?",
                    "data-cy": "kontoinhaberVersicherungsnehmer"
                  }, null, 8, _hoisted_12), [
                    [_vModelRadio, _ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle]
                  ]),
                  _cache[19] || (_cache[19] = _createElementVNode("label", {
                    for: "paymentAccountHolderCustomer",
                    class: "radiolabel"
                  }, "Der Versicherungsnehmer", -1)),
                  (_ctx.piniaStore.state.personendaten.verwalterAktiv)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "paymentAccountHolderVerwalter",
                          name: "paymentAccountHolder",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle) = $event)),
                          value: 'verwalter',
                          required: _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                          "aria-required": _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                          "aria-label": "Der Kontoinhaber ist der Verwalter",
                          "data-fehlermeldung": "Sind Sie selbst oder eine andere Person der Kontoinhaber?",
                          "data-cy": "kontoinhaberVerwalter"
                        }, null, 8, _hoisted_14), [
                          [_vModelRadio, _ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle]
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("label", {
                          for: "paymentAccountHolderVerwalter",
                          class: "radiolabel"
                        }, "Der Verwalter", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "paymentAccountHolderOther",
                    name: "paymentAccountHolder",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle) = $event)),
                    value: 'anderePerson',
                    required: _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                    "aria-required": _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                    "aria-label": "Der Kontoinhaber ist eine andere Person",
                    "data-fehlermeldung": "Sind Sie selbst oder eine andere Person der Kontoinhaber?",
                    "data-cy": "kontoinhaberAnderePerson"
                  }, null, 8, _hoisted_15), [
                    [_vModelRadio, _ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle]
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("label", {
                    for: "paymentAccountHolderOther",
                    class: "radiolabel"
                  }, "andere Person", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.paymentAccountHolder,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [19,20]
              })
            ]),
            _: 1
          }),
          (_ctx.kontoinhaberIstAnderePerson)
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                _createVNode(_component_zeile, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_titel_zelle, null, {
                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                        _createTextVNode("Vorname und Name")
                      ])),
                      _: 1,
                      __: [21]
                    }),
                    _createVNode(_component_zelle, { breite: 3 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "paymentAccountHolderFirstName",
                          name: "paymentAccountHolderFirstName",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartner.vorname) = $event)),
                          class: "c-form-control__input",
                          placeholder: "Vorname",
                          minlength: "2",
                          maxlength: "40",
                          required: _ctx.kontoinhaberIstAnderePerson,
                          "aria-required": _ctx.kontoinhaberIstAnderePerson,
                          "aria-label": "Vorname des Kontoinhabers",
                          "data-fehlermeldung": "Bitte geben Sie den Vornamen ein (2-40 Zeichen).",
                          "data-cy": "kontoinhaberPartnerVorname"
                        }, null, 8, _hoisted_17), [
                          [
                            _vModelText,
                            _ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartner.vorname,
                            void 0,
                            {
                              lazy: true,
                              trim: true
                            }
                          ]
                        ]),
                        _createVNode(_component_validierungs_fehler, {
                          "fehler-text": _ctx.fehler.paymentAccountHolderFirstName
                        }, null, 8, ["fehler-text"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_zelle, { breite: 3 }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "paymentAccountHolderName",
                          name: "paymentAccountHolderName",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartner.nachname) = $event)),
                          class: "c-form-control__input",
                          placeholder: "Name",
                          minlength: "2",
                          maxlength: "40",
                          required: _ctx.kontoinhaberIstAnderePerson,
                          "aria-required": _ctx.kontoinhaberIstAnderePerson,
                          "aria-label": "Nachname des Kontoinhabers",
                          "data-fehlermeldung": "Bitte geben Sie den Nachnamen ein (2-40 Zeichen).",
                          "data-cy": "kontoinhaberPartnerNachname"
                        }, null, 8, _hoisted_18), [
                          [
                            _vModelText,
                            _ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartner.nachname,
                            void 0,
                            {
                              lazy: true,
                              trim: true
                            }
                          ]
                        ]),
                        _createVNode(_component_validierungs_fehler, {
                          "fehler-text": _ctx.fehler.paymentAccountHolderName
                        }, null, 8, ["fehler-text"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.zahlungsdaten.kontoinhaberPartnerRolle !== '')
            ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, null, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("IBAN")
                    ])),
                    _: 1,
                    __: [22]
                  }),
                  _createVNode(_component_zelle, null, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "paymentIban",
                        name: "paymentIban",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.zahlungsdaten.iban) = $event)),
                        class: "c-form-control__input",
                        placeholder: "IBAN",
                        minlength: "27",
                        maxlength: "27",
                        required: _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                        "aria-required": _ctx.piniaStore.state.zahlungsdaten.zahlungsart === 'debit',
                        "aria-label": "IBAN",
                        "data-fehlermeldung": "Bitte geben Sie eine deutsche IBAN ein (22 Zeichen).",
                        "data-cy": "iban"
                      }, null, 8, _hoisted_19), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.zahlungsdaten.iban,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.paymentIban
                      }, null, 8, ["fehler-text"]),
                      _cache[23] || (_cache[23] = _createElementVNode("div", {
                        class: "notice-box__iban",
                        id: "paymentIbanInfo"
                      }, [
                        _createElementVNode("p", null, [
                          _createTextVNode(" Ich ermächtige die GEV, Zahlungen von dem hier angegebenen Konto mittels Lastschrift einzuziehen. Zugleich wird das Kreditinstitut angewiesen, die von der GEV gezogenen Lastschriften einzulösen."),
                          _createElementVNode("br"),
                          _createTextVNode(" Hinweis: Innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, kann die Erstattung des belasteten Betrages verlangt werden. Es gelten dabei die mit dem Kreditinstitut vereinbarten Bedingungen. ")
                        ])
                      ], -1))
                    ]),
                    _: 1,
                    __: [23]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}